/* External dependencies */
import { Container, Div, Text } from 'atomize';
import React from 'react';
import { Link, useTranslation } from 'gatsby-plugin-react-i18next';

/* Local dependencies */
import DropdownIntl from '@components/website/header/dropdown-intl/DropdownIntl';
import '../../styles/styles.scss';

interface MeducationHeaderProps {
  headerTitle?: string | React.ReactElement;
  isLabel?: boolean;
  isSwitchLocale?: boolean;
}

export default function MeducationHeader({
  isLabel = true,
  isSwitchLocale = true,
  headerTitle = 'meducation',
}: MeducationHeaderProps) {
  const { t } = useTranslation();

  return (
    <Div
      tag="header"
      className="meducation-header"
      p={!isLabel && { y: { sm: '2rem' } }}
      m={{ b: { xs: '2rem', sm: '0' } }}
    >
      <Container>
        <Div
          d="flex"
          justify="space-between"
          align={{ xs: 'start', sm: 'center' }}
        >
          <Div d="flex" flexDir={{ xs: 'column', sm: 'row' }} align="center">
            {isLabel && (
              <Link
                className="meducation-header_bookmark"
                style={{ minWidth: '127px' }}
                to="/"
              >
                <Text
                  textSize="smallSize1"
                  className="meducation-header_title"
                  dangerouslySetInnerHTML={{
                    __html: t('basedOnApp', {
                      medcheck: '<span>Medcheck</span>',
                    }),
                  }}
                />
              </Link>
            )}
            <Text
              tag="h3"
              fontFamily="secondary"
              textSize={{ xs: 'medium', md: 'display' }}
              textColor="#fff"
              m={{
                l: { sm: '1.5rem' },
              }}
            >
              {headerTitle}
            </Text>
          </Div>
          {isSwitchLocale && (
            <Div m={{ t: { xs: '1rem', sm: '0' } }}>
              <DropdownIntl color="#fff" arrowColor="#fff" />
            </Div>
          )}
        </Div>
      </Container>
    </Div>
  );
}
